var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvertisers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1050_14136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0367 4.52663L13.6738 24.4961L4.84835 33.3216C3.38388 34.786 3.38388 37.1604 4.84835 38.6249L7.50007 41.2766C8.96454 42.7411 11.3389 42.7411 12.8034 41.2766L21.6289 32.4512L41.5984 23.0883M44.25 25.7398L20.3851 1.875M40.4333 11.3167L44.25 9.375M34.8083 5.69166L36.75 1.875",
    stroke: "#F7CDFD",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3261 37.7539L23.5597 44.9874C24.2411 45.689 25.1946 46.125 26.25 46.125C28.3211 46.125 30 44.4459 30 42.375C30 41.3197 29.564 40.3661 28.8625 39.6847L13.6738 24.4961",
    stroke: "#F7CDFD",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1050_14136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvertisers);
export default __webpack_public_path__ + "static/media/advertisers.05b1f4705fc22e671fbe8a1125c3972e.svg";
export { ForwardRef as ReactComponent };